/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_No_Presets_TitleInputs */



/**
* | output |
* | --- |
* | "No export presets" |
*
* @param {Explorer_Info_Batch_No_Presets_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_no_presets_title = /** @type {((inputs?: Explorer_Info_Batch_No_Presets_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_No_Presets_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun préréglage d'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Exportvoreinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun preset di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет настроек экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay preajustes de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无导出预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートプリセットなし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई निर्यात प्रीसेट नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sem predefinições de exportação")
	return /** @type {LocalizedString} */ ("No export presets")
});